import { NavLink } from 'react-router-dom';
import { haptics } from '../telegram';
import { HomeIcon, ChartIcon, CalendarIcon, UserIcon } from './icons';

const tabs = [
  { to: '/', label: 'Главная', Icon: HomeIcon },
  { to: '/leaderboard', label: 'Рейтинг', Icon: ChartIcon },
  { to: '/schedule', label: 'Турниры', Icon: CalendarIcon },
  { to: '/profile', label: 'Профиль', Icon: UserIcon },
];

export function TabBar() {
  return (
    <nav className="tabbar">
      {tabs.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          onClick={() => haptics.tap()}
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          <span className="ico">
            <Icon />
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
